var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardicon4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 48,
    viewBox: "0 0 52 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4281 14.2464C19.6536 16.0229 18.3481 17.5108 16.7106 18.5212L18.9013 29.9799H12.0528L10.1055 19.787C6.21106 19.1096 3.14638 16.0784 2.40511 12.1922C1.66383 8.29493 3.40085 4.35323 6.76426 2.27689L8.12511 9.37196L12.0528 12.0479L14.7191 8.10618L13.3583 1C16.2349 1.49965 18.7243 3.30951 20.1072 5.8966C21.4902 8.48369 21.6009 11.5593 20.4281 14.2464ZM35.9064 2.35461C35.2426 5.34143 31.7464 7.32894 26.9447 6.26301L26.0043 10.4823L48.4417 15.4899L50.6213 5.64122L35.8953 2.35461H35.9064ZM31.4477 29.991L35.3089 12.5697L41.6928 13.991L37.9643 29.991H31.4366H31.4477ZM50.7872 44.6253V29.991H1V44.6253C1 45.8244 1.97362 46.8015 3.16851 46.8015H48.6298C49.8247 46.8015 50.7983 45.8244 50.7983 44.6253H50.7872ZM29.1353 33.2443C29.1353 35.043 27.686 36.4976 25.8936 36.4976C24.1013 36.4976 22.6519 35.043 22.6519 33.2443V29.991H29.1464V33.2443H29.1353Z",
    stroke: "#00FD8E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardicon4);
export default __webpack_public_path__ + "static/media/cardicon4.aa8fb4d18ce9ed4eef25a84af337dd05.svg";
export { ForwardRef as ReactComponent };